import { UnsyncedChangeModel } from '../../models/unsynced-change.model';

/**
 * Versioned, self-describing envelope for an export of the local
 * `unsyncedChanges` table (Issue #2). Written to a JSON file as a last-resort
 * safety net before any destructive local-data recovery action so a forced
 * clear is not silently lossy. The `formatVersion` lets a future support import
 * tool detect the schema; `dbVersion` records the Dexie schema the changes were
 * produced against.
 */
export interface UnsyncedChangesExport {
    formatVersion: number;
    dbVersion: number;
    exportedAt: string;
    changes: UnsyncedChangeModel[];
}

/** Current export envelope format version. Bump on any breaking shape change. */
export const UNSYNCED_CHANGES_EXPORT_FORMAT_VERSION = 1;

/**
 * Builds the export envelope. Pure and side-effect-free so it is trivially
 * testable; the actual file download is a separate concern.
 */
export function buildUnsyncedChangesExport(
    changes: UnsyncedChangeModel[],
    dbVersion: number
): UnsyncedChangesExport {
    return {
        formatVersion: UNSYNCED_CHANGES_EXPORT_FORMAT_VERSION,
        dbVersion,
        exportedAt: new Date().toISOString(),
        changes: changes ?? []
    };
}
